var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import { getPxStyle, getTransformPropValue } from './shared';
export class TabPane extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.offsetX = 0;
        this.offsetY = 0;
        this.setLayout = (div) => {
            this.layout = div;
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.active !== nextProps.active) {
            if (nextProps.active) {
                this.offsetX = 0;
                this.offsetY = 0;
            }
            else {
                this.offsetX = this.layout.scrollLeft;
                this.offsetY = this.layout.scrollTop;
            }
        }
    }
    render() {
        const _a = this.props, { active, fixX, fixY } = _a, props = __rest(_a, ["active", "fixX", "fixY"]);
        let style = Object.assign({}, fixX && this.offsetX ? getTransformPropValue(getPxStyle(-this.offsetX, 'px', false)) : {}, fixY && this.offsetY ? getTransformPropValue(getPxStyle(-this.offsetY, 'px', true)) : {});
        return <div {...props} style={style} ref={this.setLayout}>
      {props.children}
    </div>;
    }
}
TabPane.defaultProps = {
    fixX: true,
    fixY: true,
};



// WEBPACK FOOTER //
// ./components/tabs/rmc-tabs/TabPane.tsx